import { render } from "./MapSchemeView.vue?vue&type=template&id=bbaefbc8&scoped=true"
import script from "./MapSchemeView.vue?vue&type=script&lang=js"
export * from "./MapSchemeView.vue?vue&type=script&lang=js"

import "./MapSchemeView.vue?vue&type=style&index=0&id=bbaefbc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbaefbc8"]])

export default __exports__